// Admin (users) + Pagination i18n fragment
const fragment = {
  vi: {
    // ----- index.js (Admin list page) -----
    'adminUsers.index.title': 'Tài khoản quản trị',
    'adminUsers.index.add': 'Thêm',
    'adminUsers.index.downloadTemplateSuccess': 'Tải mẫu danh mục thành công',
    'adminUsers.index.downloadTemplateError': 'Tải mẫu danh mục thất bại',
    'adminUsers.index.importSuccess': 'Tải lên danh mục thành công',
    'adminUsers.index.importError': 'Tải lên danh mục thất bại',
    'adminUsers.index.importFormatError': 'Chỉ hỗ trợ tải lại file định dạng .xlsx, xls',

    // ----- Table.js -----
    'adminUsers.table.colUsername': 'Tên đăng nhập',
    'adminUsers.table.colCreatedAt': 'Ngày tạo',
    'adminUsers.table.colRole': 'Vai trò',
    'adminUsers.table.colActions': 'Thao tác',
    'adminUsers.table.rolePlaceholder': 'Chọn cấp độ',
    'adminUsers.table.thisAccount': 'tài khoản này',
    'adminUsers.table.tooltipResetPassword': 'Đặt lại mật khẩu',
    'adminUsers.table.tooltipDelete': 'Xóa tài khoản',
    'adminUsers.table.emptyTitle': 'Chưa có dữ liệu',
    'adminUsers.table.emptyDesc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',
    'adminUsers.table.deleteTitle': 'Xoá tài khoản quản trị?',
    'adminUsers.table.deleteDesc': 'Tài khoản {username} sẽ bị xoá vĩnh viễn.',
    'adminUsers.table.deleteConfirm': 'Xoá',
    'adminUsers.table.deleteSuccess': 'Xóa tài khoản quản trị thành công',
    'adminUsers.table.deleteError': 'Xóa tài khoản quản trị không thành công',
    'adminUsers.table.changeRoleTitle': 'Đổi vai trò?',
    'adminUsers.table.changeRoleDesc': 'Đổi vai trò của {username} thành "{role}"?',
    'adminUsers.table.changeRoleConfirm': 'Cập nhật',
    'adminUsers.table.changeRoleSuccess': 'Thay đổi vai trò thành công',
    'adminUsers.table.changeRoleError': 'Thay đổi vai trò cho tài khoản này không thành công',
    'adminUsers.table.resetPasswordTitle': 'Đặt lại mật khẩu?',
    'adminUsers.table.resetPasswordDesc':
      'Mật khẩu sẽ được đặt về giá trị mặc định. Người dùng phải đăng nhập lại.',
    'adminUsers.table.resetPasswordConfirm': 'Đặt lại',
    'adminUsers.table.resetPasswordSuccess': 'Đặt lại mật khẩu cho tài khoản này thành công',
    'adminUsers.table.resetPasswordDefault': 'Mật khẩu mặc định là {password}',
    'adminUsers.table.resetPasswordError': 'Đặt lại mật khẩu cho tài khoản này không thành công',

    // ----- CreateAdminModal.js -----
    'adminUsers.createModal.title': 'Tạo quản trị viên',
    'adminUsers.createModal.usernameLabel': 'Tên đăng nhập',
    'adminUsers.createModal.passwordLabel': 'Mật khẩu',
    'adminUsers.createModal.roleLabel': 'Vai trò',
    'adminUsers.createModal.rolePlaceholder': 'Vai trò',
    'adminUsers.createModal.cancel': 'Hủy',
    'adminUsers.createModal.submit': 'Tạo',
    'adminUsers.createModal.createSuccess': 'Tạo quản trị viên thành công',

    // ----- AssignPermission.js -----
    'adminUsers.assignPermission.title': 'Cấp quyền truy cập',
    'adminUsers.assignPermission.cancel': 'Hủy',
    'adminUsers.assignPermission.update': 'Cập nhật',
    'adminUsers.assignPermission.updateSuccess': 'Cập nhật quyền thành công',

    // ----- UpdatePassword.js -----
    'adminUsers.updatePassword.title': 'Cập nhật mật khẩu',
    'adminUsers.updatePassword.oldPasswordLabel': 'Mật khẩu cũ',
    'adminUsers.updatePassword.newPasswordLabel': 'Mật khẩu mới',
    'adminUsers.updatePassword.confirmPasswordLabel': 'Xác nhận mật khẩu mới',
    'adminUsers.updatePassword.showPassword': 'Hiện mật khẩu',
    'adminUsers.updatePassword.hidePassword': 'Ẩn mật khẩu',
    'adminUsers.updatePassword.cancel': 'Hủy',
    'adminUsers.updatePassword.update': 'Cập nhật',
    'adminUsers.updatePassword.updateSuccess': 'Cập nhật mật khẩu thành công',

    // ----- Pagination.js -----
    'common.pagination.prev': 'Trước',
    'common.pagination.next': 'Tiếp',
  },
  en: {
    // ----- index.js (Admin list page) -----
    'adminUsers.index.title': 'Admin accounts',
    'adminUsers.index.add': 'Add',
    'adminUsers.index.downloadTemplateSuccess': 'Category template downloaded successfully',
    'adminUsers.index.downloadTemplateError': 'Failed to download category template',
    'adminUsers.index.importSuccess': 'Categories imported successfully',
    'adminUsers.index.importError': 'Failed to import categories',
    'adminUsers.index.importFormatError': 'Only .xlsx and .xls files are supported',

    // ----- Table.js -----
    'adminUsers.table.colUsername': 'Username',
    'adminUsers.table.colCreatedAt': 'Created date',
    'adminUsers.table.colRole': 'Role',
    'adminUsers.table.colActions': 'Actions',
    'adminUsers.table.rolePlaceholder': 'Select level',
    'adminUsers.table.thisAccount': 'this account',
    'adminUsers.table.tooltipResetPassword': 'Reset password',
    'adminUsers.table.tooltipDelete': 'Delete account',
    'adminUsers.table.emptyTitle': 'No data yet',
    'adminUsers.table.emptyDesc': 'Add the first record to get started',
    'adminUsers.table.deleteTitle': 'Delete admin account?',
    'adminUsers.table.deleteDesc': 'Account {username} will be permanently deleted.',
    'adminUsers.table.deleteConfirm': 'Delete',
    'adminUsers.table.deleteSuccess': 'Admin account deleted successfully',
    'adminUsers.table.deleteError': 'Failed to delete admin account',
    'adminUsers.table.changeRoleTitle': 'Change role?',
    'adminUsers.table.changeRoleDesc': 'Change the role of {username} to "{role}"?',
    'adminUsers.table.changeRoleConfirm': 'Update',
    'adminUsers.table.changeRoleSuccess': 'Role changed successfully',
    'adminUsers.table.changeRoleError': 'Failed to change the role for this account',
    'adminUsers.table.resetPasswordTitle': 'Reset password?',
    'adminUsers.table.resetPasswordDesc':
      'The password will be reset to the default value. The user must sign in again.',
    'adminUsers.table.resetPasswordConfirm': 'Reset',
    'adminUsers.table.resetPasswordSuccess': 'Password for this account reset successfully',
    'adminUsers.table.resetPasswordDefault': 'The default password is {password}',
    'adminUsers.table.resetPasswordError': 'Failed to reset the password for this account',

    // ----- CreateAdminModal.js -----
    'adminUsers.createModal.title': 'Create administrator',
    'adminUsers.createModal.usernameLabel': 'Username',
    'adminUsers.createModal.passwordLabel': 'Password',
    'adminUsers.createModal.roleLabel': 'Role',
    'adminUsers.createModal.rolePlaceholder': 'Role',
    'adminUsers.createModal.cancel': 'Cancel',
    'adminUsers.createModal.submit': 'Create',
    'adminUsers.createModal.createSuccess': 'Administrator created successfully',

    // ----- AssignPermission.js -----
    'adminUsers.assignPermission.title': 'Grant access permissions',
    'adminUsers.assignPermission.cancel': 'Cancel',
    'adminUsers.assignPermission.update': 'Update',
    'adminUsers.assignPermission.updateSuccess': 'Permissions updated successfully',

    // ----- UpdatePassword.js -----
    'adminUsers.updatePassword.title': 'Update password',
    'adminUsers.updatePassword.oldPasswordLabel': 'Current password',
    'adminUsers.updatePassword.newPasswordLabel': 'New password',
    'adminUsers.updatePassword.confirmPasswordLabel': 'Confirm new password',
    'adminUsers.updatePassword.showPassword': 'Show password',
    'adminUsers.updatePassword.hidePassword': 'Hide password',
    'adminUsers.updatePassword.cancel': 'Cancel',
    'adminUsers.updatePassword.update': 'Update',
    'adminUsers.updatePassword.updateSuccess': 'Password updated successfully',

    // ----- Pagination.js -----
    'common.pagination.prev': 'Previous',
    'common.pagination.next': 'Next',
  },
};

export default fragment;
